import styled, { css } from 'styled-components'

import FormLabel from '../FormLabel'

import { pxToRem } from './../../../theme/mixins'

export enum InputSize {
  Small = 'Small',
  Big = 'Big',
}

type InputStyleProps = {
  $isError?: boolean
  $isActive?: boolean
  $hasLabel?: boolean
  $isDisabled?: boolean
  $hasErrorMessage?: boolean
  $size?: InputSize
  $type?: any
  $placeholder?: string
}

const HintMessage = styled.p`
  ${({ theme }) => theme.textStyles.m375_bodySmall};
  margin-top: ${pxToRem(8)};
  text-align: left;
`

export const InnerHelpMessage = styled(HintMessage)`
  ${({ theme }) => theme.textStyles.d1440_button}
  color: ${({ theme }) => theme.colors.black};
`

export const HelpMessage = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.black};
`
export const ErrorMessage = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.error};
`

export const Container = styled.div<InputStyleProps>`
  display: flex;
  flex-flow: column;

  // disabled
  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      opacity: 0.8;
      &,
      & * {
        cursor: not-allowed;
      }
    `}
`

export const InputContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  position: relative;
  padding: 0 ${pxToRem(16)};

  > svg {
    margin-left: -0.5rem;
  }
`

export const MainWrapper = styled.div`
  width: 100%;
`

export const Wrapper = styled.div<InputStyleProps>`
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  width: 100%;
  height: ${pxToRem(52)};
  transition: all 0.3s ease;

  ${({ $isError, theme }) =>
    $isError === true &&
    css`
      border-color: ${theme.colors.error};
    `}

  ${({ $isActive }) =>
    $isActive === true &&
    css`
      border-color: ${({ theme }) => theme.colors.black};
    `}

  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      border-color: ${({ theme }) => theme.colors.greyAA};
    `}

  ${({ theme, $type, $isActive, $placeholder }) =>
    $type === 'date' &&
    css`
      ${InputContainer} {
        &::after {
          content: ${`'${$placeholder}'`};
          ${({ theme }) => theme.textStyles.d1440_body};
          color: ${({ theme }) => theme.colors.greyB2};
          position: absolute;
          left: 6rem;
          pointer-events: none;
          display: ${$isActive ? 'none' : 'block'};
        }

        & input {
          color: ${$isActive ? theme.colors.greyB2 : 'transparent'};
        }
      }
    `};
`

export const Label = styled(FormLabel)``

export const inputStyle = css<InputStyleProps>`
  ${({ theme }) => theme.textStyles.d1440_body};
  line-height: 1;
  width: 100%;
  height: 100%;
  border: 0;
  color: ${({ theme }) => theme.colors.black};
  background: transparent;
  transition: all 0.3s ease;
  // disabled
  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      pointer-events: none;
      color: ${({ theme }) => theme.colors.greyAA};
    `}

  ${({ $isError }) =>
    $isError === true &&
    css`
      color: ${({ theme }) => theme.colors.error};
    `}

  &::placeholder {
    color: rgba(0, 0, 0, 0.7);
    ${({ theme }) => theme.textStyles.m375_body};

    ${({ $isError }) =>
      $isError === true &&
      css`
        color: ${({ theme }) => theme.colors.error};
      `}
  }

  // readonly
  &[readonly] {
    cursor: default;
  }

  &:focus {
    outline: none;
  }

  &[type='password']&:not(:placeholder) {
    letter-spacing: 3px;
  }
`

export const Input = styled.input<InputStyleProps>`
  ${inputStyle};
`
